export enum IncidentCategory {
  NewVulnerability = 'New vulnerability',
}
